import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import { SvgIcon } from '@mui/material'
import React from 'react'
import { ValueMessageLinkedData } from '../../../../../../../shared/queries/useGetValueMessageLinkedDataQuery'
import { ReactComponent as LinkIcon } from '../../../../../../../assets/images/hyperlink.svg'
import { ReactComponent as PencilIcon } from '../../../../../../../assets/images/pencil-write-2.svg'

import { Link as RouterLink, useHistory } from 'react-router-dom'
import Link from '@mui/material/Link'
import { ValueMessage } from '../../../../../../ValueNarrativesView/queries/useGetValueNarrativesQuery'
import Box from '@mui/material/Box'

type SupportingEvidenceExpandedRowItemProps = {
    activity: ValueMessageLinkedData['ongoingActivities'][number]
    navigationStack: ArrayLike<object>
    valueMessage: ValueMessage
}

const Bulletpoint = () => <li style={{ width: 0, marginTop: '5px', fontSize: '12px' }} />

const OngoingActivitiesExpandedRowItem = ({
    activity,
    navigationStack,
    valueMessage,
}: SupportingEvidenceExpandedRowItemProps) => {
    const history = useHistory()

    const addToStack = () => {
        let arr = Array.from(navigationStack)
        arr.push({
            isAutoOpenPanel: false,
            path: history.location.pathname,
            data: valueMessage,
        })
        return arr
    }

    const trimmedTitle = activity?.title?.trim() || ''
    const cleanedTitle = trimmedTitle.endsWith('.') ? trimmedTitle.slice(0, -1) : trimmedTitle

    return (
        <Stack direction="row" gap={2} py={1.5}>
            <Bulletpoint />

            <Box flex={1}>
                <Tooltip title="Open Activity" enterDelay={600} enterNextDelay={600}>
                    <Link
                        component={RouterLink}
                        underline="none"
                        color="inherit"
                        to={{
                            pathname: '/activities',
                            autoOpenData: {
                                isAutoOpenPanel: true,
                                autoOpenData: activity,
                                previousDataStack: addToStack(),
                            },
                        }}
                    >
                        <Typography
                            variant="16x400"
                            color="figma.grayscale.textHier2"
                            lineHeight="26px"
                            sx={{
                                whiteSpace: 'break-spaces',
                                '&:hover': {
                                    textDecoration: 'underline',
                                    color: 'figma.primary',
                                    cursor: 'pointer',
                                },
                            }}
                        >
                            {cleanedTitle}
                            <span style={{ whiteSpace: 'nowrap' }}>
                                .
                                <SvgIcon
                                    component={PencilIcon}
                                    fontSize="small"
                                    color="primary"
                                    inheritViewBox
                                    sx={{
                                        marginLeft: '6px',
                                        fontSize: '14px',
                                    }}
                                />
                            </span>
                        </Typography>
                    </Link>
                </Tooltip>
            </Box>

            <Stack direction="row" gap={1}>
                {activity.title && (
                    <Tooltip title="Open Link" enterDelay={600} enterNextDelay={600}>
                        <IconButton
                            disabled={!activity.link}
                            size="small"
                            component="a"
                            href={activity.link}
                            target="_blank"
                            sx={{
                                color: !!activity.link ? 'figma.primary' : 'figma.grayscale.tier5',
                                cursor: !!activity.link ? 'alias' : 'not-allowed',
                            }}
                        >
                            <SvgIcon
                                component={LinkIcon}
                                fontSize="small"
                                color="inherit"
                                inheritViewBox
                                sx={{
                                    fontSize: '16px',
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                )}
            </Stack>
        </Stack>
    )
}

export default OngoingActivitiesExpandedRowItem
